import { pluralize } from '@nesso/ui/lib/utils';

export function formatElapsedTime(iso: string | null): string {
    if (!iso) return '';

    const elapsedMs = Date.now() - new Date(iso).getTime();
    const elapsedMinutes = Math.floor(elapsedMs / (60 * 1000));
    const elapsedHours = Math.floor(elapsedMinutes / 60);
    const elapsedDays = Math.floor(elapsedHours / 24);
    const elapsedMonths = Math.floor(elapsedDays / 30);
    const elapsedYears = Math.floor(elapsedDays / 365);

    if (elapsedMinutes < 1) return 'just now';
    if (elapsedMinutes < 60) return `${pluralize(elapsedMinutes, 'minute')} ago`;
    if (elapsedHours < 24) return `${pluralize(elapsedHours, 'hour')} ago`;
    if (elapsedDays < 30) return `${pluralize(elapsedDays, 'day')} ago`;
    if (elapsedDays < 365) return `${pluralize(elapsedMonths, 'month')} ago`;
    return `${pluralize(elapsedYears, 'year')} ago`;
}
